/*
  Multi-column video aspect-ratio sizing — extracted from sections/multi-column.liquid so it ships from a cacheable, deferred asset
  instead of inline markup. DOMContentLoaded/resize driven, so deferring changes nothing.
*/

function updateDivHeights() {
  const divsOuter = document.querySelectorAll('.gg-multi-column-video-container div.video-container--image');
  const divsVideo = document.querySelectorAll('.gg-multi-column-video-container div.video-container__video');

  divsOuter.forEach(function(div) {
    const width = div.offsetWidth;
    const newHeight = width / 1.5;
    div.style.height = newHeight + 'px';
  });

  divsVideo.forEach(function(div) {
    const width = div.offsetWidth;
    const newHeight = width / 1.5;
    div.style.height = newHeight + 'px';
  });
}

window.addEventListener('DOMContentLoaded', updateDivHeights);
window.addEventListener('resize', updateDivHeights);
